var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiAccountOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.165 12C13.74 12 12.54 13.2 12.54 14.625C12.54 16.05 13.74 17.25 15.165 17.25C16.59 17.25 17.79 16.05 17.79 14.625C17.79 13.2 16.59 12 15.165 12Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 14.625C11.04 13.125 11.865 11.775 13.065 11.1C12.09 10.725 10.89 10.5 9.54004 10.5C6.24004 10.5 3.54004 11.85 3.54004 13.5V15H11.04V14.625ZM12.54 6C12.54 7.65 11.19 9 9.54004 9C7.89004 9 6.54004 7.65 6.54004 6C6.54004 4.35 7.89004 3 9.54004 3C11.19 3 12.54 4.35 12.54 6Z",
    fill: "#F0F0F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAccountOnline);
export default __webpack_public_path__ + "static/media/mdi_account-online.6558b1c5b454417736e73d04ccaa63c4.svg";
export { ForwardRef as ReactComponent };